import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getGenerationSite } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  GetGenerationSiteRequestSchema,
  type GetGenerationSiteResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 発電所 (サイト) 1 件の取得 hook。編集ダイアログを開いた時に最新を取り直し、
 * 返る `updatedAt` を更新の `expectedUpdatedAt` (楽観ロック) に渡す。
 * `id` が undefined または空文字の時は query を無効化する。
 *
 * - `throwOnError: false`: 取得失敗 (他の利用者が削除した NotFound 等) はダイアログ内に出す。
 *   QueryClient 既定の `throwOnError: true` のままだと画面全体のエラーになる
 * - `gcTime: 0`: ダイアログを閉じたら結果を捨て、開くたびに最新が届くまで入力を始めさせない
 *   (前回の結果が残っていると、取り直し中に古い値で入力・保存できてしまう)
 */
export function useGetGenerationSite(
  id: string | undefined,
): UseQueryResult<GetGenerationSiteResponse, ConnectError> {
  return useQuery(
    getGenerationSite,
    create(GetGenerationSiteRequestSchema, { id: id ?? '' }),
    { enabled: id !== undefined && id !== '', throwOnError: false, gcTime: 0 },
  )
}
